import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = authed
  const [status, setStatus] = useState(null); // owner bootstrap status

  const loadStatus = useCallback(async () => {
    try {
      const { data } = await api.get("/api/auth/status");
      setStatus(data);
    } catch {
      setStatus(null);
    }
  }, []);

  const checkSession = useCallback(async () => {
    try {
      const { data } = await api.get("/api/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadStatus();
    checkSession();
  }, [loadStatus, checkSession]);

  const login = async (email, password) => {
    const { data } = await api.post("/api/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/api/auth/logout");
    } finally {
      setUser(false);
    }
  };

  const refreshUser = checkSession;

  return (
    <AuthContext.Provider value={{ user, setUser, status, loadStatus, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}

export function isWriter(user) {
  return user && (user.role === "admin" || user.role === "editor");
}
export function isAdmin(user) {
  return user && user.role === "admin";
}
